import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
const initialState = {
  review: [],
  status: 'idle',
  error: null,
  pagination: {
    totalDocs: 0,
    totalPages: 1,
    page: 1,
    limit: 10,
  },
};
export const fetchReview = createAsyncThunk(
  'review/fetchReview',
  async ({ page , limit , id = null }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("vedhvidhi-admin-token");
      
      // Determine URL based on id presence
      const url = id
        ? `${process.env.REACT_APP_BASEURL}/admin/review?review_id=${id}`
        : `${process.env.REACT_APP_BASEURL}/admin/review?page=${page}&limit=${limit}`;

      const response = await fetch(url, {
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) throw new Error('Failed to fetch reviews');
      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice
const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReview.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchReview.fulfilled, (state, action) => {
        state.status = 'succeeded';

        // If fetched by id, return as single object inside array, else paginated list
        if (action.meta.arg.id) {
          state.review = action.payload.data ? [action.payload.data] : [];
          state.pagination = initialState.pagination;
        } else {
          state.review = action.payload.data || [];
          state.pagination = action.payload.paginationDetail || initialState.pagination;
        }
      })
      .addCase(fetchReview.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default reviewSlice.reducer;

